import { FC } from 'react'
import CloseButton from './CloseButton'
import MuteButton from './MuteButton'
import PlaybackSpeedButton from './PlaybackSpeedButton'

export interface VideoControlsPanelProps {
  isMuted: boolean
  playbackRate: number
  onToggleMute: () => void
  onPlaybackRateChange: (rate: number) => void
  onClose?: () => void
}

const VideoControlsPanel: FC<VideoControlsPanelProps> = ({ isMuted, playbackRate, onToggleMute, onPlaybackRateChange, onClose }) => {
  return (
    <div className="absolute top-3 right-3 flex flex-col gap-1 z-30">
      {onClose && <CloseButton onClose={onClose} />}
      <MuteButton isMuted={isMuted} onToggleMute={onToggleMute} />
      <PlaybackSpeedButton playbackRate={playbackRate} onPlaybackRateChange={onPlaybackRateChange} />
    </div>
  )
}

export default VideoControlsPanel
